// Spinner.js
const Spinner = ({ size = "lg" }) => {
  const sizeClasses = {
    sm: "w-4 h-4",
    md: "w-6 h-6",
    lg: "w-8 h-8",
  };
  return (
    <div
      className={`animate-spin rounded-full border-t-2 border-blue-500 ${sizeClasses[size]}`}
    ></div>
  );
};

export default Spinner;
